<template>
  <footer class="mt-4">
    <b-navbar class="navbar-expand" toggleable type="light" variante="light" id="m68_navbar_footer">
      <b-navbar-toggle target="m68_nav_collapse_footer"></b-navbar-toggle>
      <b-collapse is-nav id="m68_nav_collapse_footer" class="justify-content-center">
        <b-navbar-nav>
          <b-nav-text><strong>© Axel Springer SE {{ date }}.</strong></b-nav-text>
          <b-nav-item :to="{ name: 'contact' }" :exact="true">Impressum</b-nav-item>
          <b-nav-text> | </b-nav-text>
          <b-nav-item :to="{ name: 'privacy' }">Hinweise zum Datenschutz</b-nav-item>
          <b-nav-text> | </b-nav-text>
          <b-nav-item :to="{ name: 'contact' }" :exact="true">Anmerkungen zu Artikeln in der Datenbank
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </footer>
</template>

<script>
  export default {
    name: 'Footer',
    data: () => ({
      date: new Date().getFullYear()
    })
  }
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue